import { Component, Input } from '@angular/core';
import { MenuPositionX, MenuPositionY } from '@angular/material/menu';
import { SvcButtonIconCustomBaseComponent } from '../svc-button-icon-custom-base';

export interface ISvcButtonEllipsisOption {
  name: string;
  icon?: string;
  iconSize?: string;
  action: () => void;
  hidden?: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'svc-button-ellipsis',
  templateUrl: './svc-button-ellipsis.component.html',
  styleUrls: ['./svc-button-ellipsis.component.scss'],
})
export class SvcButtonEllipsisComponent extends SvcButtonIconCustomBaseComponent {
  @Input('loading') set setLoading(value: boolean) {
    this.processing = value;
  }
  @Input() options: ISvcButtonEllipsisOption[] = [];
  @Input() xPosition: MenuPositionX;
  @Input() yPosition: MenuPositionY;
}
